import {Injectable} from '@angular/core';
// import {LocalStorage} from 'ngx-store';
import {environment} from '../../environments/environment';
import {LocalStorage} from '@efaps/ngx-store';

function _window(): any {
    // return the global native browser window object
    return window;
}

@Injectable({
    providedIn: 'root',
})
export class RSDebuggerService {

    private debugVal = null;
    @LocalStorage('_d') _debugging: boolean = !environment.production;
    public set debugging(debug: boolean) {
        this._debugging = !!debug;
        this.toggleDebugger();
    }
    public get debugging() {
        return !!this._debugging;
    }

    private readonly _debug: any;
    private readonly _console: any;
    public log:     Function;
    public error:   Function;
    public info:    Function;
    public warn:    Function;
    private noop    = () => {};
    private noopError = (...arg) => {
        debugger;
    };

    // Allow people to specify which / if any console methods they want to print regardless of debugger state. This is where users might be able to just in and get the info for us?
    public consolePassthrough: string[] = ['error', 'warn'];
    private _window: any;

    constructor() {

        // Get the ui window
        this._window = _window();

        // Store the console object
        this._console = this._window.console;

        // Build our debugger bindings
        this._debug = {
            log:    this._console.log.bind(this._console),
            error:  this._console.error.bind(this._console, 'error: %s'),
            info:   this._console.info.bind(this._console, 'info: %s'),
            warn:   this._console.warn.bind(this._console, 'warn: %s'),
        };

        // Make global for testing
        this._window.debug = this._debug;

        // Set up the watchers
        this.toggleDebugger();
    }

    // This'll now turn the debugger on or off depending on the debug status
    toggleDebugger() {
        const bDebugging = this.debugging;

        // Are we already toggled?
        if (this.debugVal === bDebugging) {
            return; // We're already on/off
        } else if (bDebugging) {
            // We've been summoned!
            this._debug.log('RSDebuggerService::: toggleDebugger:: debugger on');
        } else {
            // We were debugging & now not
            if (this.debugVal) {
                this._debug.log('RSDebuggerService::: toggleDebugger:: debugger off');
            }
        }

        // Access the window to hijack the console and override its methods with our own
        if (this._console) {
            for (const c in this._console) {
                if (typeof this._console[c] === 'function') {
                    if (this.debugging) {
                        // Do we handle them?
                        if (this._debug.hasOwnProperty(c)) {
                            // Pass through
                            this._window.console[c] = this._debug[c].bind(this._debug);
                        } else {
                            // Pass through
                            this._window.console[c] = this._console[c];
                        }
                    } else if (this.consolePassthrough.indexOf(c) !== -1) {
                        // We want to pass this through
                        this._window.console[c] = this._console[c];
                    } else {
                        // Debugger is off and we do not have a bypass on it so skip this
                        this._window.console[c] = this.noop;
                    }
                }
            }
        }

        // If needed, attach to our methods for people who use the debugger.log etc. ;
        // Bind to our service for people who call the debugger directly
        this.log =    (this.debugging || this.consolePassthrough.indexOf('log')     !== -1 ?   this._debug.log.bind(this._debug)   : this.noop);
        this.info =   (this.debugging || this.consolePassthrough.indexOf('info')    !== -1 ?   this._debug.info.bind(this._debug)  : this.noop);
        this.warn =   (this.debugging || this.consolePassthrough.indexOf('warn')    !== -1 ?   this._debug.warn.bind(this._debug)  : this.noop);
        this.error =  (this.debugging || this.consolePassthrough.indexOf('error')   !== -1 ?   this._debug.error.bind(this._debug) : this.noopError);

        // Remember if we were on or not
        this.debugVal = this.debugging;
    }

}
